"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAtEndOfCell = exports.isAtStartOfCell = exports.inLastTableCell = exports.getCellIndexFromCellPath = exports.getClosestTable = exports.updateTableSelections = exports.clearAndSetFocusToAnchorCell = exports.toggleMarkOnCells = exports.clearSelectedCells = exports.getCellAtIndex = exports.selectAll = exports.updateSelection = exports.resizeColumns = exports.deleteTableColumns = exports.addTableColumn = exports.deleteTableRows = exports.setRepeatingTableRowToken = exports.addRepeatingTableRow = exports.addTableRow = exports.addTableRowAndSelectNextCell = exports.addTableWidget = void 0;
var Table_1 = require("ContentTokens/DataModels/Table");
var Table_2 = require("ContentTokens/Models/Table");
var Text_1 = require("ContentTokens/Models/Text");
var TokenModels_1 = __importDefault(require("ContentTokens/TokenModels"));
var lodash_1 = require("lodash");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var Utils_1 = require("../Utils");
var EditorTypes_1 = require("./../EditorTypes");
var TableActionUtilities_1 = require("./TableActionUtilities");
var addTableWidget = function (editor, rows, columns) {
    var _a;
    if (!editor.selection) {
        return;
    }
    var tableNode = TokenModels_1.default.table.createSlateJson(rows, columns);
    var startPoint = slate_1.Range.start(editor.selection).path;
    var _b = __read((_a = (0, Utils_1.getClosestBlock)(editor, startPoint)) !== null && _a !== void 0 ? _a : [], 2), path = _b[1];
    if (!path) {
        return;
    }
    slate_1.Editor.withoutNormalizing(editor, function createTableAndSetCursorToFirstCell() {
        slate_1.Transforms.removeNodes(editor, { at: path });
        slate_1.Transforms.insertNodes(editor, tableNode, { at: path });
        var _a = __read(slate_1.Editor.nodes(editor, {
            at: path,
            match: function (node) { return node.type === EditorTypes_1.BlockType.TableRow; },
        }), 1), _b = __read(_a[0], 2), firstTableRowPath = _b[1];
        var _c = __read(slate_1.Editor.nodes(editor, { at: firstTableRowPath, match: Text_1.Text.isText }), 1), _d = __read(_c[0], 2), textPath = _d[1];
        slate_1.Transforms.select(editor, textPath);
    });
    (0, lodash_1.defer)(function () {
        slate_react_1.ReactEditor.focus(editor);
    });
};
exports.addTableWidget = addTableWidget;
var addTableRowAndSelectNextCell = function (editor) {
    var _a;
    if (!editor.selection) {
        return;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var tableEntry = (0, exports.getClosestTable)(editor, startPoint.path);
    if (!tableEntry) {
        return;
    }
    var _b = __read(tableEntry, 2), table = _b[0], tablePath = _b[1];
    (0, exports.addTableRow)(editor, tablePath, table.data.rows);
    _a = __read((0, exports.getClosestTable)(editor, startPoint.path), 2), table = _a[0], tablePath = _a[1];
    var lastRow = (0, lodash_1.last)(table.children);
    var lastRowIndex = table.children.length - 1;
    var _c = __read(slate_1.Node.texts(lastRow), 1), targetText = _c[0];
    slate_1.Transforms.select(editor, {
        path: __spreadArray(__spreadArray(__spreadArray([], __read(tablePath), false), [lastRowIndex], false), __read(targetText[1]), false),
        offset: 0,
    });
};
exports.addTableRowAndSelectNextCell = addTableRowAndSelectNextCell;
var addTableRow = function (editor, path, rowId) {
    var tableEntry = getTable(editor, path);
    if (!tableEntry) {
        throw new Error("Could not find a table at path provided");
    }
    var columns = tableEntry[0].data.columns;
    var data = (0, lodash_1.cloneDeep)(tableEntry[0].data);
    data.rows += 1;
    data.selection = null;
    slate_1.Transforms.setNodes(editor, { data: data }, { at: tableEntry[1] });
    var newRow = (0, Table_1.createEmptyTableRowNode)();
    for (var i = 0; i < columns; i++) {
        newRow.children.push((0, Table_1.createEmptyTableCellNode)());
    }
    slate_1.Transforms.insertNodes(editor, newRow, { at: __spreadArray(__spreadArray([], __read(path), false), [rowId + 1], false) });
};
exports.addTableRow = addTableRow;
var addRepeatingTableRow = function (editor, path, rowId) {
    var tableEntry = getTable(editor, path);
    if (!tableEntry) {
        throw new Error("Could not find a table at path provided");
    }
    var columns = tableEntry[0].data.columns;
    var data = (0, lodash_1.cloneDeep)(tableEntry[0].data);
    data.rows += 1;
    data.selection = null;
    slate_1.Transforms.setNodes(editor, { data: data }, { at: tableEntry[1] });
    var newRow = (0, Table_1.createEmptyTableRepeatingRowNode)();
    for (var i = 0; i < columns; i++) {
        newRow.children.push((0, Table_1.createEmptyTableCellNode)());
    }
    slate_1.Transforms.insertNodes(editor, newRow, { at: __spreadArray(__spreadArray([], __read(path), false), [rowId + 1], false) });
};
exports.addRepeatingTableRow = addRepeatingTableRow;
var setRepeatingTableRowToken = function (editor, path, repeatingToken) {
    var nodePropsToUpdate = {
        data: { repeatingToken: repeatingToken },
    };
    slate_1.Transforms.setNodes(editor, nodePropsToUpdate, { at: path });
};
exports.setRepeatingTableRowToken = setRepeatingTableRowToken;
var deleteTableRows = function (editor, path, rowIds) {
    var e_1, _a;
    var tableEntry = getTable(editor, path);
    if (!tableEntry) {
        throw new Error("Could not find a table at path provided");
    }
    var data = (0, lodash_1.cloneDeep)(tableEntry[0].data);
    data.rows -= rowIds.length;
    slate_1.Transforms.setNodes(editor, { data: data }, { at: tableEntry[1] });
    var reverseSortedRowIds = rowIds.sort(function (a, b) { return b - a; });
    try {
        for (var reverseSortedRowIds_1 = __values(reverseSortedRowIds), reverseSortedRowIds_1_1 = reverseSortedRowIds_1.next(); !reverseSortedRowIds_1_1.done; reverseSortedRowIds_1_1 = reverseSortedRowIds_1.next()) {
            var rowId = reverseSortedRowIds_1_1.value;
            try {
                var pathToRow = __spreadArray(__spreadArray([], __read(tableEntry[1]), false), [rowId + 1], false);
                slate_1.Transforms.removeNodes(editor, { at: pathToRow });
            }
            catch (error) {
                console.error(error);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (reverseSortedRowIds_1_1 && !reverseSortedRowIds_1_1.done && (_a = reverseSortedRowIds_1.return)) _a.call(reverseSortedRowIds_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    slate_react_1.ReactEditor.blur(editor);
};
exports.deleteTableRows = deleteTableRows;
var addTableColumn = function (editor, tablePath, columnIndex, columnBorders) {
    var tableEntry = slate_1.Editor.node(editor, tablePath);
    var tableNode = (0, Table_2.asTableNode)(tableEntry[0]);
    var tableRowNodes = (0, Table_2.getTableRowNodes)(tableNode);
    for (var rowIndex = 0; rowIndex < tableRowNodes.length; rowIndex++) {
        slate_1.Transforms.insertNodes(editor, (0, Table_1.createEmptyTableCellNode)(), {
            at: (0, Table_2.getTableCellPath)(tablePath, rowIndex, columnIndex),
        });
    }
    var data = (0, lodash_1.cloneDeep)(tableNode.data);
    data.columns += 1;
    data.columnBorders = (0, lodash_1.cloneDeep)(columnBorders);
    slate_1.Transforms.setNodes(editor, { data: data }, { at: tablePath });
};
exports.addTableColumn = addTableColumn;
var deleteTableColumns = function (editor, tablePath, columnIndices, columnBorders) {
    var tableEntry = slate_1.Editor.node(editor, tablePath);
    var tableNode = (0, Table_2.asTableNode)(tableEntry[0]);
    var tableRowNodes = (0, Table_2.getTableRowNodes)(tableNode);
    var data = (0, lodash_1.cloneDeep)(tableNode.data);
    data.columns -= columnIndices.length;
    data.columnBorders = (0, lodash_1.cloneDeep)(columnBorders);
    slate_1.Transforms.setNodes(editor, { data: data }, { at: tablePath });
    var reverseSortedColumnsIndices = columnIndices.sort(function (a, b) { return b - a; });
    var _loop_1 = function (rowIndex) {
        reverseSortedColumnsIndices.forEach(function (columnIndex) {
            try {
                slate_1.Transforms.removeNodes(editor, { at: (0, Table_2.getTableCellPath)(tablePath, rowIndex, columnIndex) });
            }
            catch (error) {
                console.error(error);
            }
        });
    };
    for (var rowIndex = 0; rowIndex < tableRowNodes.length; rowIndex++) {
        _loop_1(rowIndex);
    }
    slate_react_1.ReactEditor.blur(editor);
};
exports.deleteTableColumns = deleteTableColumns;
var resizeColumns = function (editor, path, columnBorders) {
    var tableEntry = getTable(editor, path);
    if (!tableEntry) {
        throw new Error("Could not find a table at path provided");
    }
    var data = (0, lodash_1.cloneDeep)(tableEntry[0].data);
    data.columnBorders = (0, lodash_1.cloneDeep)(columnBorders);
    slate_1.Transforms.setNodes(editor, { data: data }, { at: tableEntry[1] });
};
exports.resizeColumns = resizeColumns;
var updateSelection = function (editor, path, selectionUpdate) {
    var tableEntry = null;
    try {
        tableEntry = getTable(editor, path);
    }
    catch (e) {
        return;
    }
    if (!tableEntry) {
        return;
    }
    var data = (0, lodash_1.cloneDeep)(tableEntry[0].data);
    var selectedCells = (0, TableActionUtilities_1.getSelectedCells)(selectionUpdate.anchorCell, selectionUpdate.focusCell, data.rows, data.columns);
    data.selection = __assign(__assign({}, selectionUpdate), { selectedCells: selectedCells });
    if (selectedCells.length > 0) {
        slate_1.Transforms.select(editor, slate_1.Editor.start(editor, __spreadArray(__spreadArray([], __read(tableEntry[1]), false), [0], false)));
    }
    slate_1.Transforms.setNodes(editor, { data: data }, { at: tableEntry[1] });
};
exports.updateSelection = updateSelection;
var selectAll = function (editor, path) {
    if (!editor.selection) {
        return;
    }
    var tableEntry = getTable(editor, path);
    if (!tableEntry) {
        throw new Error("Could not find a table at path provided");
    }
    var data = (0, lodash_1.cloneDeep)(tableEntry[0].data);
    var selectedCells = (0, TableActionUtilities_1.getSelectedCells)(0, data.columns * data.rows - 1, data.rows, data.columns);
    data.selection = {
        anchorCell: 0,
        focusCell: data.columns * data.rows - 1,
        selectedCells: selectedCells,
    };
    var selection = editor.selection;
    var tableDummyPath = [path[0], 0];
    var textNodePoint = slate_1.Editor.start(editor, tableDummyPath);
    if (slate_1.Path.compare(selection.anchor.path, path) === 0) {
        slate_1.Transforms.setPoint(editor, textNodePoint, { edge: "anchor" });
    }
    if (slate_1.Path.compare(selection.focus.path, path) === 0) {
        slate_1.Transforms.setPoint(editor, textNodePoint, { edge: "focus" });
    }
    slate_react_1.ReactEditor.focus(editor);
    slate_1.Transforms.setNodes(editor, { data: data }, { at: tableEntry[1] });
};
exports.selectAll = selectAll;
var getCellAtIndex = function (index, tableEntry) {
    var _a = __read(tableEntry, 2), table = _a[0], tablePath = _a[1];
    var columns = table.data.columns;
    var rowId = Math.floor(index / columns) + 1;
    var columnId = index % columns;
    return [table.children[rowId].children[columnId], __spreadArray(__spreadArray([], __read(tablePath), false), [rowId, columnId], false)];
};
exports.getCellAtIndex = getCellAtIndex;
var clearSelectedCells = function (editor) {
    if (!editor.selection) {
        return;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var tableEntry = (0, exports.getClosestTable)(editor, startPoint.path);
    if (!tableEntry || !tableEntry[0].data.selection) {
        return;
    }
    var data = tableEntry[0].data;
    var selectedCells = data.selection.selectedCells;
    slate_1.Editor.withoutNormalizing(editor, function () {
        for (var i = 0; i < selectedCells.length; i++) {
            if (!selectedCells[i]) {
                continue;
            }
            var _a = __read((0, exports.getCellAtIndex)(i, tableEntry), 2), selectedCell = _a[0], pathToCell = _a[1];
            for (var childIndex = selectedCell.children.length - 1; childIndex >= 0; childIndex--) {
                var pathToContent = __spreadArray(__spreadArray([], __read(pathToCell), false), [childIndex], false);
                slate_1.Transforms.removeNodes(editor, { at: pathToContent });
            }
            var blankParagraph = TokenModels_1.default.paragraph.createSlateJson([TokenModels_1.default.text.createSlateJson("", {})]);
            slate_1.Transforms.insertNodes(editor, blankParagraph, { at: __spreadArray(__spreadArray([], __read(pathToCell), false), [0], false) });
        }
    });
};
exports.clearSelectedCells = clearSelectedCells;
var toggleMarkOnCells = function (editor, mark) {
    if (!editor.selection) {
        return;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var tableEntry = (0, exports.getClosestTable)(editor, startPoint.path);
    if (!tableEntry || !tableEntry[0].data.selection) {
        return;
    }
    var data = tableEntry[0].data;
    var selectedCells = data.selection.selectedCells;
    var isMarked = selectedContainsMark(mark, tableEntry, selectedCells);
    if (!isMarked) {
        setMarkOnCells(mark, editor, tableEntry, selectedCells);
    }
    else {
        unsetMarkOnCells(mark, editor, tableEntry, selectedCells);
    }
};
exports.toggleMarkOnCells = toggleMarkOnCells;
var clearAndSetFocusToAnchorCell = function (editor) {
    if (!editor.selection) {
        return;
    }
    (0, exports.clearSelectedCells)(editor);
    var tableEntry = (0, exports.getClosestTable)(editor, slate_1.Range.start(editor.selection).path);
    if (!tableEntry) {
        return;
    }
    var data = (0, lodash_1.cloneDeep)(tableEntry[0].data);
    var anchorIdx = data.selection ? data.selection.anchorCell : 0;
    data.selection = undefined;
    slate_1.Transforms.setNodes(editor, { data: data }, { at: tableEntry[1] });
    var _a = __read((0, exports.getCellAtIndex)(anchorIdx, tableEntry), 2), firstCell = _a[0], firstCellPath = _a[1];
    var _b = __read(slate_1.Node.texts(firstCell), 1), targetText = _b[0];
    var targetPath = __spreadArray(__spreadArray([], __read(firstCellPath), false), __read(targetText[1]), false);
    slate_1.Transforms.select(editor, { path: targetPath, offset: 0 });
};
exports.clearAndSetFocusToAnchorCell = clearAndSetFocusToAnchorCell;
var updateTableSelections = function (editor) {
    if (!editor.selection) {
        return;
    }
    var selection = editor.selection;
    var anchorIndex = selection.anchor.path[0];
    var focusIndex = selection.focus.path[0];
    if (isSelectionWithinOneTable(editor, anchorIndex, focusIndex)) {
        selectWithinTable(editor, anchorIndex);
    }
    else if (isSelectingLastCell(editor, anchorIndex, focusIndex)) {
        selectLastCell(editor, anchorIndex);
    }
    else {
        selectWholeTables(editor, anchorIndex, focusIndex);
    }
};
exports.updateTableSelections = updateTableSelections;
var selectedContainsMark = function (mark, tableEntry, selectedCells) {
    for (var i = 0; i < selectedCells.length; i++) {
        var _a = __read((0, exports.getCellAtIndex)(i, tableEntry), 1), selectedCell = _a[0];
        var cellHasMark = hasMark(selectedCell, mark);
        if (cellHasMark) {
            return true;
        }
    }
    return false;
};
var setMarkOnCells = function (mark, editor, tableEntry, selectedCells) {
    var e_2, _a;
    for (var i = 0; i < selectedCells.length; i++) {
        if (!selectedCells[i]) {
            continue;
        }
        var _b = __read((0, exports.getCellAtIndex)(i, tableEntry), 2), selectedCell = _b[0], selectedCellPath = _b[1];
        var texts = slate_1.Node.texts(selectedCell);
        try {
            for (var texts_1 = (e_2 = void 0, __values(texts)), texts_1_1 = texts_1.next(); !texts_1_1.done; texts_1_1 = texts_1.next()) {
                var text = texts_1_1.value;
                var marks = (0, lodash_1.cloneDeep)(text[0].marks);
                marks.push({ data: {}, type: mark });
                slate_1.Transforms.setNodes(editor, { marks: marks }, { at: __spreadArray(__spreadArray([], __read(selectedCellPath), false), __read(text[1]), false) });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (texts_1_1 && !texts_1_1.done && (_a = texts_1.return)) _a.call(texts_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
    }
};
var unsetMarkOnCells = function (mark, editor, tableEntry, selectedCells) {
    var e_3, _a;
    for (var i = 0; i < selectedCells.length; i++) {
        if (!selectedCells[i]) {
            continue;
        }
        var _b = __read((0, exports.getCellAtIndex)(i, tableEntry), 2), selectedCell = _b[0], selectedCellPath = _b[1];
        var texts = slate_1.Node.texts(selectedCell);
        try {
            for (var texts_2 = (e_3 = void 0, __values(texts)), texts_2_1 = texts_2.next(); !texts_2_1.done; texts_2_1 = texts_2.next()) {
                var text = texts_2_1.value;
                var marks = (0, lodash_1.cloneDeep)(text[0].marks);
                var filteredMarks = marks.filter(function (curr) { return curr.type !== mark; });
                var textPath = __spreadArray(__spreadArray([], __read(selectedCellPath), false), __read(text[1]), false);
                slate_1.Transforms.setNodes(editor, { marks: filteredMarks }, { at: textPath });
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (texts_2_1 && !texts_2_1.done && (_a = texts_2.return)) _a.call(texts_2);
            }
            finally { if (e_3) throw e_3.error; }
        }
    }
};
var getClosestTable = function (editor, path) {
    return (0, Utils_1.checkAncestors)(editor, path, function (curr) { return curr.type === EditorTypes_1.BlockType.Table; });
};
exports.getClosestTable = getClosestTable;
var hasMark = function (node, markType) {
    if (Text_1.Text.isText(node)) {
        return node.marks.some(function (mark) { return mark.type === markType; });
    }
    else {
        return node.children.some(function (child) { return hasMark(child, markType); });
    }
};
var isSelectionWithinOneTable = function (editor, anchorIndex, focusIndex) {
    var isWithin = anchorIndex === focusIndex && editor.children[anchorIndex].type === "table";
    return isWithin;
};
var isSelectingLastCell = function (editor, anchorIndex, focusIndex) {
    var _a, _b;
    var child = editor.children[anchorIndex];
    var isTable = child.type === "table";
    if (!isTable) {
        return false;
    }
    var tableNode = (0, Table_2.asTableNode)(child);
    var cellCount = tableNode.data.rows * tableNode.data.columns;
    var selectionAnchorCell = (_b = (_a = tableNode.data) === null || _a === void 0 ? void 0 : _a.selection) === null || _b === void 0 ? void 0 : _b.anchorCell;
    var isTheLastCellSelected = selectionAnchorCell === cellCount - 1 && focusIndex === anchorIndex + 1;
    return isTheLastCellSelected;
};
var getCellIndexFromCellPath = function (editor, path) {
    var _a = __read((0, lodash_1.take)(path, 3), 3), tableIndex = _a[0], rowIndex = _a[1], colIndex = _a[2];
    var table = (0, Table_2.asTableNode)(editor.children[tableIndex]);
    var columnCount = table.data.columns;
    var cellIndex = (rowIndex - 1) * columnCount + colIndex;
    return cellIndex;
};
exports.getCellIndexFromCellPath = getCellIndexFromCellPath;
var selectWithinTable = function (editor, tableIndex) {
    if (!editor.selection) {
        return;
    }
    var selection = editor.selection;
    if ([selection.anchor.path[1], selection.focus.path[1]].includes(0)) {
        return;
    }
    var anchorCellIndex = (0, exports.getCellIndexFromCellPath)(editor, selection.anchor.path);
    var focusCellIndex = (0, exports.getCellIndexFromCellPath)(editor, selection.focus.path);
    if (anchorCellIndex !== focusCellIndex) {
        if (isPointAtStartOfBlock(editor, selection.focus)) {
            focusCellIndex -= 1;
        }
        (0, exports.updateSelection)(editor, [tableIndex], {
            anchorCell: anchorCellIndex,
            focusCell: focusCellIndex,
        });
    }
};
var selectLastCell = function (editor, tableIndex) {
    var table = (0, Table_2.asTableNode)(editor.children[tableIndex]);
    var cellCount = table.data.columns * table.data.rows;
    var lastCellIndex = cellCount - 1;
    (0, exports.updateSelection)(editor, [tableIndex], {
        anchorCell: lastCellIndex,
        focusCell: lastCellIndex,
    });
};
var selectWholeTables = function (editor, startIndex, endIndex) {
    for (var i = startIndex; i <= endIndex; i++) {
        var block = editor.children[i];
        if (block.type === EditorTypes_1.BlockType.Table) {
            (0, exports.selectAll)(editor, [i]);
        }
    }
};
var isPointAtStartOfBlock = function (editor, point) {
    var parentBlock = (0, Utils_1.getClosestBlock)(editor, point.path);
    if (!parentBlock) {
        return false;
    }
    return (0, Utils_1.getOffsetFrom)(editor, parentBlock[1], point.path) == 0 && point.offset == 0;
};
var inLastTableCell = function (editor) {
    if (!editor.selection) {
        return false;
    }
    var startPoint = slate_1.Range.start(editor.selection);
    var tableCellEntry = (0, Utils_1.checkAncestors)(editor, startPoint.path, function (curr) {
        return curr.type === EditorTypes_1.BlockType.TableCell;
    });
    if (!tableCellEntry) {
        return false;
    }
    var tableEntry = (0, Utils_1.checkAncestors)(editor, tableCellEntry[1], function (curr) { return curr.type === EditorTypes_1.BlockType.Table; });
    var _a = __read(tableEntry, 2), table = _a[0], tablePath = _a[1];
    var cellPath = tableCellEntry[1];
    var cellIndex = (0, exports.getCellIndexFromCellPath)(editor, cellPath);
    var lastCellPath = __spreadArray(__spreadArray([], __read(tablePath), false), [table.data.rows, table.data.columns - 1], false);
    var lastCellIndex = (0, exports.getCellIndexFromCellPath)(editor, lastCellPath);
    return cellIndex === lastCellIndex;
};
exports.inLastTableCell = inLastTableCell;
var isAtStartOfCell = function (editor) {
    return isAtPointOfCell(editor, slate_1.Editor.start);
};
exports.isAtStartOfCell = isAtStartOfCell;
var isAtEndOfCell = function (editor) {
    return isAtPointOfCell(editor, slate_1.Editor.end);
};
exports.isAtEndOfCell = isAtEndOfCell;
var isAtPointOfCell = function (editor, getPoint) {
    var selection = editor.selection;
    if (selection && slate_1.Range.isCollapsed(selection)) {
        var cellPath = getCellPath(editor);
        if (cellPath) {
            var end = getPoint(editor, cellPath);
            if (slate_1.Point.equals(selection.anchor, end)) {
                return true;
            }
        }
    }
    return false;
};
var getCellPath = function (editor) {
    var _a = __read(slate_1.Editor.nodes(editor, {
        match: function (n) { return n.type === EditorTypes_1.BlockType.TableCell; },
    }), 1), cell = _a[0];
    if (cell) {
        return cell[1];
    }
};
var getTable = function (editor, path) {
    var maybeTableEntry = slate_1.Editor.node(editor, path);
    if (!maybeTableEntry) {
        return null;
    }
    else if (maybeTableEntry[0].type === EditorTypes_1.BlockType.Table) {
        return maybeTableEntry;
    }
    else {
        throw new Error("Attempting to get table with path that doesn't lead to a table");
    }
};
